import { render } from "./IntroVideo.vue?vue&type=template&id=4e354ddc&ts=true"
import script from "./IntroVideo.vue?vue&type=script&lang=ts"
export * from "./IntroVideo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__